function _assert_this_initialized(self1) {
    if (self1 === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self1;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self1, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self1);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { Nielsen } from '@sky-uk-ott/core-video-sdk-js-external-nielsen';
import { PerfKey } from '../../../../utils/perf';
import { AgfNielsenBrowserSdkAddon } from '../../../reporting/agf-nielsen/agf-nielsen-browser-sdk/agf-nielsen-browser-sdk-addon';
import { AddonLoader } from '../../addon-loader';
import { JsonUtils } from '../../../../utils/json-utils';
import { sdkLogger } from '../../../../logger';
import { CvsdkError, ErrorSeverity } from '../../../../error';
import { AddonSdks } from '../../../../core/session-controller/session-controller.enums';
import { isDisabledForNoConsent } from '../reporting-addon-loader';
export var AgfNielsenBrowserSdkAddonLoader = /*#__PURE__*/ function(AddonLoader) {
    "use strict";
    _inherits(AgfNielsenBrowserSdkAddonLoader, AddonLoader);
    function AgfNielsenBrowserSdkAddonLoader(device) {
        _class_call_check(this, AgfNielsenBrowserSdkAddonLoader);
        var _this;
        _this = _call_super(this, AgfNielsenBrowserSdkAddonLoader, [
            device
        ]), _define_property(_this, "device", void 0), _define_property(_this, "perfKey", void 0), _define_property(_this, "agfNielsenSdkInstance", void 0), _define_property(_this, "domlessNielsenSdkLocalStorage", void 0), _define_property(_this, "logger", void 0), _define_property(_this, "isIon", void 0), _define_property(_this, "create", void 0), _this.device = device, _this.perfKey = PerfKey.agfNielsenBrowserSdk, _this.domlessNielsenSdkLocalStorage = new Map(), _this.logger = sdkLogger.withContext('AgfNielsenBrowserSdkAddonLoader'), _this.create = function(reportingAddonSessionData) {
            var _sessionItem_addons, _reportingSessionConfig_agfNielsen;
            var session = reportingAddonSessionData.session, reportingSessionConfig = reportingAddonSessionData.reportingSessionConfig, sessionItem = reportingAddonSessionData.sessionItem;
            var isSdkOptedOut = isDisabledForNoConsent(AgfNielsenBrowserSdkAddon.requiresUserConsentToBeUsed, sessionItem === null || sessionItem === void 0 ? void 0 : (_sessionItem_addons = sessionItem.addons) === null || _sessionItem_addons === void 0 ? void 0 : _sessionItem_addons.optedOutSdks, AddonSdks.AGF_NIELSEN, 'AGF Nielsen SDK Addon Loader');
            if (!(reportingSessionConfig === null || reportingSessionConfig === void 0 ? void 0 : (_reportingSessionConfig_agfNielsen = reportingSessionConfig.agfNielsen) === null || _reportingSessionConfig_agfNielsen === void 0 ? void 0 : _reportingSessionConfig_agfNielsen.enabled) || isSdkOptedOut) {
                return;
            }
            var nrsUrl = reportingSessionConfig.agfNielsen.config.nrsUrl;
            var config = {
                nrsUrl: nrsUrl
            };
            var agfNielsenBrowserSdkAddon = _this.construct(config, session, sessionItem, _this.agfNielsenSdkInstance, _this.isIon);
            return agfNielsenBrowserSdkAddon;
        };
        _this.isIon = _this.device.type === DeviceType.Ion;
        return _this;
    }
    _create_class(AgfNielsenBrowserSdkAddonLoader, [
        {
            key: "checkIsModuleRequired",
            value: function checkIsModuleRequired(internalConfigPerPlaybackType) {
                var isEnabled = this.checkInternalConfigLeaves(internalConfigPerPlaybackType, 'addons.reporting.agfNielsen.enabled', true);
                return isEnabled;
            }
        },
        {
            key: "moduleLoader",
            value: function moduleLoader(internalConfigPerPlaybackType) {
                var _this = this;
                return _async_to_generator(function() {
                    var _internalConfigPerPlaybackType_default_addons_reporting_agfNielsen, _internalConfigPerPlaybackType_default_addons_reporting, config, instanceMetadata, implementationHooks, AgfNielsenBrowserSdkAddon;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!self.NOLBUNDLE && !_this.isIon) {
                                    _this.readyAGFNielsenBrowserSdk(self, 'NOLBUNDLE');
                                }
                                if (!_this.agfNielsenSdkInstance) {
                                    ;
                                    config = (_internalConfigPerPlaybackType_default_addons_reporting = internalConfigPerPlaybackType.default.addons.reporting) === null || _internalConfigPerPlaybackType_default_addons_reporting === void 0 ? void 0 : (_internalConfigPerPlaybackType_default_addons_reporting_agfNielsen = _internalConfigPerPlaybackType_default_addons_reporting.agfNielsen) === null || _internalConfigPerPlaybackType_default_addons_reporting_agfNielsen === void 0 ? void 0 : _internalConfigPerPlaybackType_default_addons_reporting_agfNielsen.config;
                                    if (!config) {
                                        throw CvsdkError.from({
                                            code: 'ADDONS_LOADER.AGF_NIELSEN_BROWSER_SDK.NO_CONFIG',
                                            message: 'No config provided. Cannot load AGF Nielsen module.',
                                            severity: ErrorSeverity.Warning
                                        });
                                    }
                                    if (_this.isIon) {
                                        instanceMetadata = _this.getDomlessNielsenSdkInstanceMetadata(config);
                                        implementationHooks = _this.getDomlessNielsenSdkImplementationHooks(_this.logger.withContext('DomlessNielsenSdk'));
                                        _this.agfNielsenSdkInstance = new Nielsen.BsdkInstance(config.apId, config.appName, instanceMetadata, implementationHooks);
                                    } else {
                                        _this.agfNielsenSdkInstance = self.NOLBUNDLE.nlsQ(config.apId, config.appName, config.debug ? {
                                            nol_sdkDebug: 'debug'
                                        } : undefined);
                                    }
                                }
                                return [
                                    4,
                                    import(/* webpackChunkName: "sdk-ad-agf-nielsen-browser-sdk" */ '../../../reporting/agf-nielsen/agf-nielsen-browser-sdk/agf-nielsen-browser-sdk-addon')
                                ];
                            case 1:
                                AgfNielsenBrowserSdkAddon = _state.sent().AgfNielsenBrowserSdkAddon;
                                return [
                                    2,
                                    AgfNielsenBrowserSdkAddon
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDomlessNielsenSdkInstanceMetadata",
            value: function getDomlessNielsenSdkInstanceMetadata(config) {
                return _object_spread({
                    // cspell:disable-next-line
                    apid: config.apId,
                    appName: config.appName,
                    deviceId: this.device.deviceInfo.uniqueDeviceId,
                    domlessEnv: '1'
                }, config.debug && {
                    nol_sdkDebug: 'debug'
                });
            }
        },
        {
            key: "getDomlessNielsenSdkImplementationHooks",
            value: function getDomlessNielsenSdkImplementationHooks(logger) {
                var _this = this;
                return {
                    Log: {
                        info: function(log) {
                            return logger.info(JsonUtils.stringify(log));
                        },
                        debug: function(log) {
                            return logger.verbose(JsonUtils.stringify(log));
                        },
                        warn: function(log) {
                            return logger.warn(JsonUtils.stringify(log));
                        },
                        error: function(log) {
                            return logger.error(JsonUtils.stringify(log));
                        }
                    },
                    Storage: {
                        setItem: function(key, value) {
                            _this.domlessNielsenSdkLocalStorage.set(key, value);
                        },
                        getItem: function(key) {
                            return _this.domlessNielsenSdkLocalStorage.get(key);
                        },
                        removeItem: function(key) {
                            _this.domlessNielsenSdkLocalStorage.delete(key);
                        }
                    },
                    Fetch: /*#__PURE__*/ function() {
                        var _ref = _async_to_generator(function(url, options) {
                            var response, responseError;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            fetch(url, options)
                                        ];
                                    case 1:
                                        response = _state.sent();
                                        if (response.ok) {
                                            logger.info("Fetch successful at ".concat(url));
                                            return [
                                                2,
                                                response
                                            ];
                                        } else {
                                            responseError = {
                                                code: 'ADDONS_LOADER.AGF_NIELSEN_BROWSER_SDK.FETCH_FAILED',
                                                message: "Fetch failed at ".concat(url),
                                                severity: ErrorSeverity.Warning
                                            };
                                            logger.error(responseError);
                                            throw CvsdkError.from(responseError);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(url, options) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    SetTimeout: function(cb, timeout) {
                        return setTimeout(cb, timeout);
                    },
                    SetInterval: function(cb, interval) {
                        return setTimeout(cb, interval);
                    },
                    ClearTimeout: function(timeout) {
                        return clearTimeout(timeout);
                    },
                    ClearInterval: function(interval) {
                        return clearTimeout(interval);
                    }
                };
            }
        },
        {
            key: "readyAGFNielsenBrowserSdk",
            value: /* eslint-disable -- This is directly from Nielsen */ function readyAGFNielsenBrowserSdk(e, n) {
                // This is taken from Nielsen integration guide: https://engineeringportal.nielsen.com/docs/DCR_Germany_Static_Browser_SDK#Step_1:_Add_Static_Queue_Snippet
                function t(e) {
                    return 'object' == (typeof e === "undefined" ? "undefined" : _type_of(e)) ? JsonUtils.parse(JsonUtils.stringify(e)) : e;
                }
                e[n] = e[n] || {
                    nlsQ: function nlsQ(o, r, c) {
                        var s = e.document, a = s.createElement('script');
                        a.async = 1, a.src = ('http:' === e.location.protocol ? 'http:' : 'https:') + '//cdn-gl.nmrodam.com/conf/' + o + '.js#name=' + r + '&ns=' + n;
                        var i = s.getElementsByTagName('script')[0];
                        return i.parentNode.insertBefore(a, i), e[n][r] = e[n][r] || {
                            g: c || {},
                            ggPM: function ggPM(o, c, s, a, i) {
                                e[n][r].q = e[n][r].q || [];
                                try {
                                    var l = t([
                                        o,
                                        c,
                                        s,
                                        a,
                                        i
                                    ]);
                                    e[n][r].q.push(l);
                                } catch (e) {
                                    console && console.log && console.log('Error: Cannot register event in Nielsen SDK queue.');
                                }
                            },
                            trackEvent: function trackEvent(o) {
                                e[n][r].te = e[n][r].te || [];
                                try {
                                    var _$c = t(o);
                                    e[n][r].te.push(_$c);
                                } catch (e) {
                                    console && console.log && console.log('Error: Cannot register event in Nielsen SDK queue.');
                                }
                            }
                        }, e[n][r];
                    }
                };
            }
        }
    ]);
    return AgfNielsenBrowserSdkAddonLoader;
} /* eslint-enable */ (AddonLoader);

//# sourceMappingURL=agf-nielsen-browser-sdk-addon-loader.js.map